import { createContext } from 'react';

/** @internal */
export interface NotifyButtonContextType {
  closeOverlay: () => void;
  overlayAriaLabelledBy?: string;
}

/** @internal */
export const NotifyButtonContext = createContext<NotifyButtonContextType>({
  closeOverlay: () => undefined,
  overlayAriaLabelledBy: undefined,
});
